import React from 'react'
import { Route } from 'react-router'

import ClientDetail from '@/modules/client/components/detail/client-detail'
import ClientList from '@/modules/client/components/list/client-list'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'
import lang from '@/lang'

const clientRoutes = (
  <>
    <Route path='client/*' element={<RedirectToPlural />} />
    <Route path='clients' Component={ClientList} handle={{ title: lang.clientList.title, options: { noBackgroundColor: true } }} />
    <Route path='clients/:id' Component={ClientDetail} />
  </>
)

export default clientRoutes
